define('views/content/metrik',['require','typeahead','bloodhound','jquery.scrollbar','moment','views/components/metrik/company_settings','views/components/metrik/metrik_license','models/customer','models/customer_product','views/components/metrik_user/metrik_users','collections/metrik_users','views/modals/metrik_add','text!templates/content/metrik.html'],function (require) {
  require("typeahead");
  require("bloodhound");
  require("jquery.scrollbar");

  var moment = require("moment");

  var CompanySettingsView = require("views/components/metrik/company_settings");
  var MetrikLicenseView = require("views/components/metrik/metrik_license");

  var CustomerModel = require("models/customer");
  var CustomerProductModel = require("models/customer_product");

  var UsersView = require("views/components/metrik_user/metrik_users");
  var UsersCollection = require("collections/metrik_users");

  var MetrikUserAddModal = require("views/modals/metrik_add");

  var license_user_limits = {
    metriKstandard: 3,
    metriKbasic: 1,
    metriKpremium: 5,
  };

  var temp = require("text!templates/content/metrik.html");
  return Backbone.Marionette.LayoutView.extend({
    // html template for the view
    template: _.template(temp),
    className: "metrik-page page",
    titleKey: "metrik",
    count: -1,

    initialize: function () {
      _.bindAll(this, "refreshMetrikUserList");
      _.bindAll(this, "newUserButtonClicked");

      var _this = this;

      App.context.changePageTitle(App.polyglot.t(this.titleKey));
      this.userCollection = new UsersCollection();

      this.listenTo(this.userCollection, "fetch_complete", function (context) {
        _this.count = this.userCollection.length;
        _this.updateUserCount(this.userCollection.length, _this.limit);
      });

      this.testw = "sdsa";
    },
    ui: function () {
      return {
        userTab: ".users-tab",
        userContainer: ".users-container",
        userCount: ".users-count",
        newUserButton: "#new-user",
      };
    },

    events: {
      "click @ui.newUserButton": "newUserButtonClicked",
    },

    regions: function () {
      return {
        CompanySettingsContainer: ".company-settings",
        MetrikLicenseContainer: ".metrik-license-container",
        UsersContainer: ".user-list",
        UsersCount: ".users-count",
      };
    },

    updateUserCount: function (count, limit) {
      var text = "";
      if (limit == 5) text = "( " + count + " )";
      else text = "( " + count + " / " + limit + " )";

      this.ui.userCount.text(text);
    },

    getMetrikUsers: function (limit) {
      this.limit = limit;

      this.usersView = new UsersView({
        collection: this.userCollection,
      });
      this.UsersContainer.show(this.usersView);
    },

    getMetrikLicenses: function () {
      var _this = this;

      $.ajax({
        url: App.Config.apiBase + "customer-licenses.json?name=metrik",

        type: "GET",

        data: {
          end_time_gte: moment().format("YYYY-MM-DD"),
        },

        success: function (data) {
          var results = data.results;

          var response = _this.findMetrikUserLimit(results);

          _this.MetrikLicenseContainer.show(
            new MetrikLicenseView({
              model: new CustomerProductModel(response.license),
            })
          );

          if (results.length) {
            _this.getMetrikUsers(response.limit);

            _this.ui.userContainer.removeClass("d-none");
          }
        },
      });
    },

    refreshMetrikUserList: function () {
      this.usersView.render();
    },

    newUserButtonClicked: function () {
      if (this.count >= 0) {
        if (this.count >= this.limit && this.limit != 5) {
          App.utils.showMessage(
            "warning",
            App.polyglot.t("metrik_user_limit_message")
          );
        } else {
          App.modalRegion.show(
            new MetrikUserAddModal({
              callback: this.refreshMetrikUserList,
            })
          );
        }
      }
    },

    onRender: function () {
      var _this = this;

      var customer = new CustomerModel({
        id: App.user.get("customer"),
      });

      customer.fetch({
        success: function () {
          _this.CompanySettingsContainer.show(
            new CompanySettingsView({
              model: customer,
            })
          );
        },
      });

      this.getMetrikLicenses();
    },

    findMetrikUserLimit: function (licenses) {
      var response = { limit: 0, license: {} };

      for (var i = 0; i < licenses.length; i++) {
          if(license_user_limits[licenses[i].product.license_name] > response.limit)
            response = {
                limit: license_user_limits[licenses[i].product.license_name],
                license: licenses[i],
              };
      }

      return response;
    },
  });
});

